import { Box, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Marshal } from "../../../fstn/marshal";

const useStyles = makeStyles(theme => ({
    action: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "x-small"
    },
    actions: {
        color: theme.palette.primary.contrastText,
        flexGrow: 1,
        maxHeight: 60,
        overflowY: "scroll",
        paddingLeft: theme.spacing(1),
        backgroundColor: "Background",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    },
    container:{
        minHeight: "60px"
    }
}));

interface Props
{
    actions: Marshal[]
}

export default function Actions({ actions }: Props)
{
    const classes = useStyles();

    const buildMarshalName = (marshal: Marshal) =>
    {
        const possibleParameters = ["reference", "lhs", "operator", "rhs", "key", "value", "increment"];
        let name = `${marshal.action}:`;

        possibleParameters.forEach(possibleParameter =>
        {
            if (marshal.parameters[possibleParameter] !== undefined)
            {
                name += ` ${marshal.parameters[possibleParameter].marshal}`
            }
        });
        return name;
    };

    return <Box className={classes.container}>
        {actions.length > 0 && <Box className={classes.actions}>
            {actions.map((action: Marshal, index: number) => (
                <Typography key={index} className={classes.action} title={JSON.stringify(action)}>
                    {buildMarshalName(action)}
                </Typography>
            ))}
        </Box>
        }
    </Box>
}